import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiClientsPartnersIdService(id) {
  return fetch(`clients/${id}/partners`, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
